import { render } from "./SystemAdmin20.vue?vue&type=template&id=0e237836"
import script from "./SystemAdmin20.vue?vue&type=script&lang=js"
export * from "./SystemAdmin20.vue?vue&type=script&lang=js"

import "./SystemAdmin20.vue?vue&type=style&index=0&id=0e237836&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__